<!-- TODO Mobile Responsive-->

<div class="finzy-row font-weight-bold">
    <p>Loan Details Prior To Restructuring</p>
</div>
<div class="d-flex flex-column mt-3">
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Loan Status Before Restructuring</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.statusBeforeRestructure}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Outstanding Principal Before Restructuring</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.principalOutstandingBeforeRestructure | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Written Off Amount Before Restructuring</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.principalOutstandingBeforeRestructure | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Old Tenure</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.oldTenure}} Months</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Old EMI</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.oldEmi | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Old ROI
        </div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.oldRoi}}%</div>
    </div>
</div>
<div class="finzy-row font-weight-bold">
    <p>Loan Details Post Restructuring</p>
</div>
<div class="d-flex flex-column">
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Loan Restructured On</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.restructuringDate}}</div>
    </div>

    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Upfront Payment (if any)</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.upfrontPayment | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Principal Written Off / Written Back
            <app-tooltip placement="right">
                <i class="info-icon material-icons" trigger>info_outline</i>
                <div content style="max-width: 300px;">Negative value is a write off and positive value is a write
                    back.
                </div>
            </app-tooltip>
        </div>
        <div class="p-4 font-weight-bold"> {{loanRestructureDetail.principalWriteOffOrWriteBack | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Capitalised Interest (due to restructuring)</div>
        <div class="p-4 font-weight-bold"> {{loanRestructureDetail.capitalisedInterest | indianCurrency}}</div>
    </div>

    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Outstanding Principal</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.principalOutstandingPostRestructure | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">New ROI</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.roiPostRestructure}}%</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">New Tenure</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.tenurePostRestructure}} Months</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">New EMI</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.emi | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">First EMI Date Post Restructuring</div>
        <div class="p-4 font-weight-bold">{{loanRestructureDetail.restructuredFirstEmiDate}}</div>
    </div>
</div>
